// `/meus-quadrinhos` — O ACERVO PESSOAL.
//
// É a rota que o pedido T2 cobra em seis pontos diferentes, e a mais citada de todas:
//
//   T2.24  "não tem tipo como eu verificar as coisas que eu criei"
//   T2.35  "os meus quadrinhos têm que abrir seu acervo"
//   T2.40  "ele abre como uma rota chamada Dashboard, só não faz sentido ser esse nome de rota"
//   T2.41  "a única forma de abrir a rota do acervo é esse continuar editando, que não é o ponto"
//   T2.42  "em vez de continuar editando, é ver meus quadrinhos"
//   T2.45  "o fato de eu ter apenas uma conta dashboard para tudo complica. Tem que ser rotas
//           para cada um"
//
// ── O QUE ESTAVA ERRADO, E POR QUE ELE ACERTOU DE FORA DA TELA ───────────────────────────────
//
// O `/dashboard` era UMA rota com uma máquina de três estados dentro:
//
//     currentComic === undefined  →  a tela dos dois balões
//     currentComic === null       →  a lista
//     currentComic é um Comic     →  o editor
//
// Três telas, um endereço, um `useState`. Isso explica, em conjunto, todas as seis queixas
// acima — não são seis defeitos, são seis sintomas do mesmo. A lista não tinha endereço, então
// o único jeito de alcançá-la era o botão "continuar editando"; o editor não tinha endereço,
// então "voltar" saía da área inteira; e o nome que aparecia na barra era o da única rota que
// existia.
//
// Agora são quatro endereços, um por coisa:
//
//     /meus-quadrinhos             o acervo         (esta tela)
//     /meus-quadrinhos/novo        escolher formato
//     /meus-quadrinhos/:id         ver o quadrinho  (T2.43)
//     /meus-quadrinhos/:id/editar  editar
//
// ── O QUE ISTO APAGOU DE PROPÓSITO ──────────────────────────────────────────────────────────
//
// A tela dos dois balões — "Novo quadrinho" e "Continuar editando" — deixou de existir. É o
// T2.31 ("os meus quadrinhos, ele abre o novo quadrinho, continuar editando") e o T2.50 ("ao
// invés daquele novo quadrinho continuar editando, pode ser editar de fato o que você quer
// editar, ou visualizar"). Quem abre "Meus quadrinhos" cai no acervo, que é o que ele pediu.
//
// As duas artes (`novo-quadrinho-btn.png`, `continuar-editando-btn.png`) ficam órfãs. Não as
// apago aqui: arte é do design, e quem decide que peça sai do repositório não sou eu.

import { useLocation, useNavigate } from "react-router-dom";
import GuardaDoAcervo from "./guarda";
import ImportComic from "../importar-comic/importar-comic";

import { useTituloDaAba } from "../../hooks/use-titulo-da-aba";
function Acervo() {
  // T8.39 · o acervo dizia so "HQ-Lab", e e a tela em que a pessoa passa mais tempo com a aba aberta.
  useTituloDaAba("Meus quadrinhos");
  const navigate = useNavigate();
  const local = useLocation();

  // Quem acabou de publicar volta para ca pelo `state` da navegacao. `state` e nao query string
  // pela mesma razao do destino de volta do login: nao e endereco para compartilhar, e recarregar
  // a pagina deve limpar o aviso em vez de repeti-lo para sempre.
  const publicou = (local.state as {
    publicou?: string;
    publicado?: boolean;
    finalizado?: boolean;
  } | null)?.publicou;

  return (
    <GuardaDoAcervo>
      {({ appUser }) => (
        <ImportComic
          appUser={appUser}
          aoCriarNovo={() => navigate("/meus-quadrinhos/novo")}
          aoVer={(comic) => navigate(`/meus-quadrinhos/${comic.getId()}`)}
          aoEditar={(comic) => navigate(`/meus-quadrinhos/${comic.getId()}/editar`)}
          aoPublicar={(comic) => navigate(`/meus-quadrinhos/${comic.getId()}/publicar`)}
          publicou={
            publicou
              ? {
                  titulo: publicou,
                  publicado: !!(local.state as { publicado?: boolean }).publicado,
                  finalizado: !!(local.state as { finalizado?: boolean }).finalizado,
                }
              : undefined
          }
        />
      )}
    </GuardaDoAcervo>
  );
}

export default Acervo;
